import React from 'react'
import {
  Box,
  IconButton
} from '@mui/material'
import {
  Menu as MenuIcon,
  Search as SearchIcon
} from '@mui/icons-material'
import { useStyles } from './style'
import { PaidConsumerNavLogo } from './paid-consumer-nav-logo'
import { PaidConsumerNavMenu } from './paid-consumer-nav-menu'
import { PaidConsumerSearchBar } from '../search/paid-consumer-search-bar'
import { Profile as ProfileIcon } from '../icons'

export const DesktopNavigation = ({ onProfileMenuOpen }) => {
  const classes = useStyles()

  return (
    <Box className={classes.desktopNav}>
      {/* Top Section: Logo centered with Profile on the right */}
      <Box className={classes.topSection}>
        <Box className={classes.logoCenter}>
          <PaidConsumerNavLogo />
        </Box>
        <IconButton
          onClick={onProfileMenuOpen}
          className={classes.profileButton}
          data-test='paid-consumer-nav-profile'
          aria-label='Open profile menu'
        >
          <ProfileIcon />
        </IconButton>
      </Box>

      {/* Bottom Section: Navigation and Search */}
      <Box className={classes.bottomSection}>
        {/* Left Section: Navigation Items */}
        <Box className={classes.navSection}>
          <PaidConsumerNavMenu />
        </Box>

        {/* Right Section: Search */}
        <Box className={classes.rightSection}>
          <PaidConsumerSearchBar />
        </Box>
      </Box>
    </Box>
  )
}

export const MobileNavigation = ({
  onMenuToggle,
  onProfileMenuOpen,
  onSearchToggle,
  searchExpanded
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.mobileNav}>
      <IconButton
        onClick={onMenuToggle}
        className={classes.mobileMenuButton}
        data-test='paid-consumer-nav-mobile-menu'
        aria-label='Open mobile menu'
      >
        <MenuIcon />
      </IconButton>

      <PaidConsumerNavLogo />

      <Box className={classes.mobileActions}>
        <IconButton
          onClick={onSearchToggle}
          className={classes.mobileActionButton}
          data-test='paid-consumer-nav-mobile-search'
          aria-label='Toggle search'
        >
          <SearchIcon />
        </IconButton>
        <IconButton
          onClick={onProfileMenuOpen}
          className={classes.mobileActionButton}
          data-test='paid-consumer-nav-mobile-profile'
          aria-label='Open profile menu'
        >
          <ProfileIcon />
        </IconButton>
      </Box>

      {searchExpanded && (
        <Box className={classes.mobileSearchExpanded}>
          <Box className={classes.mobileSearchHeader}>
            <Box
              className={classes.mobileSearchContainer}
              onClick={(e) => {
                // Focus the search input when clicking the container
                const input = e.currentTarget.querySelector('input')
                if (input) input.focus()
              }}
            >
              <PaidConsumerSearchBar
                mobile
                onClose={() => onSearchToggle(false)}
              />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}
